module.exports = __webpack_public_path__ + "static/the-box-236353e2b748b5a6e66a881e57af7efc.jpg";